<template>
  <div>
    <back-btn />
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Erro ao buscar lista
      </h4>
    </b-alert>

    <b-card
      no-body
      class="mb-0"
    >
      <b-card-body class="">
        <b-row>
          <b-col md="3">
            <div>
              <b-button-group class="mb-1">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :class="{'btn-primary': type === 'cpf'}"
                  @click="openTab('cpf')"
                >
                  CPF
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :class="{'btn-primary': type === 'cnpj'}"
                  @click="openTab('cnpj')"
                >
                  CNPJ
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :class="{'btn-primary': type === 'crm'}"
                  @click="openTab('crm')"
                >
                  CRM
                </b-button>
              </b-button-group>
            </div>
            <validation-observer
              ref="refFormObserver"
              #default="{ handleSubmit }"
            >
              <b-form
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <div v-show="type === 'cpf'">
                  <b-form-group
                    label="CPF"
                    label-for="cpf"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="CPF"
                      vid="email"
                      :rules="type === 'cpf' ? `required|cpf` : ''"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid':null"
                      >
                        <b-form-input
                          id="cpf"
                          v-model="userData.cpf"
                          v-mask="'###.###.###-##'"
                          :state="errors.length > 0 ? false:null"
                          class="form-control-merge"
                          type="text"
                          name="cpf"
                          autocomplete="off"
                          placeholder="000.000.000-00"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div v-show="type === 'cnpj'">
                  <b-form-group
                    label="CNPJ"
                    label-for="cnpj"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="CNPJ"
                      vid="cnpj"
                      :rules="type === 'cnpj' ? `required|cnpj` : ''"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid':null"
                      >
                        <b-form-input
                          id="cnpj"
                          v-model="userData.cnpj"
                          v-mask="CNPJ_MASK"
                          :state="errors.length > 0 ? false:null"
                          class="form-control-merge"
                          type="text"
                          name="cnpj"
                          autocomplete="off"
                          placeholder="00.000.000/0000-00"
                          @input="userData.cnpj = formatCnpjInput($event)"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div v-show="type === 'crm'">
                  <div class="d-flex align-content-center">
                    <b-form-group
                      label="Estado"
                      label-for="state"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Estado"
                        vid="state"
                        :rules="type === 'crm' ? `required` : ''"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid':null"
                        >
                          <v-select
                            id="state"
                            v-model="userData.state"
                            name="state"
                            :options="stateOptions"
                            label="label"
                            item-value="value"
                            item-text="label"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label="CRM"
                      label-for="crm"
                      class="ml-1"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="CRM"
                        vid="crm"
                        :rules="type === 'crm' ? `required|min:1` : ''"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid':null"
                        >
                          <b-form-input
                            id="crm"
                            v-model="userData.crm"
                            :state="errors.length > 0 ? false:null"
                            class="form-control-merge"
                            type="text"
                            name="crm"
                            autocomplete="off"
                            placeholder="0000"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                </div>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="btn-icon"
                  type="submit"
                >
                  Buscar
                </b-button>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col md="9">
            <div v-if="loading">
              <div class="text-center">
                <b-spinner
                  variant="primary"
                  label="Text Centered"
                />
              </div>
            </div>
            <div
              v-else-if="userCpf && type === 'cpf'"
            >
              <h2 :class="{'deleted': userCpf.deleted}">
                {{ userCpf.name }}
              </h2>
              <div :class="{'deleted': userCpf.deleted}">
                <b-badge
                  pill
                  variant="light-primary"
                  class="text-capitalize mb-1"
                >
                  {{ userCpf.status }}
                </b-badge>
                <div><strong>CPF:</strong> {{ userCpf.cpf }}</div>
                <div><strong>Data de Nascimento:</strong> {{ userCpf.bithdate }}</div>
              </div>
              <div class="mt-1">
                <b-button
                  v-if="!userCpf.deleted"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="btn-icon"
                  @click="removeCpfCnpj(userCpf)"
                >
                  Remover
                </b-button>
                <h4
                  v-else
                  class="text-success"
                >
                  Removido
                </h4>
              </div>
            </div>
            <div
              v-else-if="userCnpj && type === 'cnpj'"
            >
              <div :class="{'deleted': userCnpj.deleted}">
                <h2>{{ userCnpj.name }}</h2>
                <h5>{{ userCnpj.other_name }}</h5>
                <div>
                  <b-badge
                    pill
                    variant="light-primary"
                    class="text-capitalize mb-1"
                  >
                    {{ userCnpj.status }}
                  </b-badge>
                  <div><strong>CNPJ:</strong> {{ userCnpj.cnpj }}</div>
                </div>
                <div class="mt-1">
                  <h4>Quadro societário</h4>
                  <b-table
                    ref="refUserListTable"
                    class="position-relative"
                    :items="userCnpj.partners"
                    responsive
                    :fields="tableColumns"
                  >
                    aef
                  </b-table>
                </div>
              </div>
              <div class="mt-1">
                <b-button
                  v-if="!userCnpj.deleted"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="btn-icon"
                  @click="removeCpfCnpj(userCnpj)"
                >
                  Remover
                </b-button>
                <h4
                  v-else
                  class="text-success"
                >
                  Removido
                </h4>
              </div>
            </div>
            <div
              v-else-if="userCrm && type === 'crm'"
            >
              <h2 :class="{'deleted': userCrm.deleted}">
                {{ userCrm.name }}
              </h2>
              <div :class="{'deleted': userCrm.deleted}">
                <b-badge
                  pill
                  variant="light-primary"
                  class="text-capitalize mb-1"
                >
                  {{ userCrm.status }}
                </b-badge>
                <div><strong>CRM:</strong> {{ userCrm.crm }}</div>
                <div><strong>Estado:</strong> {{ userCrm.state }}</div>
              </div>
              <div class="mt-1">
                <b-button
                  v-if="!userCrm.deleted"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="btn-icon"
                  @click="removeCrm(userCrm)"
                >
                  Remover
                </b-button>
                <h4
                  v-else
                  class="text-success"
                >
                  Removido
                </h4>
              </div>
            </div>
            <div v-else>
              Nenhum registro encontrado
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BRow,
  BButtonGroup,
  BBadge,
  BTable,
  BSpinner,
} from 'bootstrap-vue'
import BackBtn from '@core/components/navigation/BackBtn.vue'
import {
  CNPJ_MASK, formatCnpjInput, formatCpf, formatDateTimeDDMMYYHHMM, normalizeCnpj,
} from '@core/utils/utils'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  alphaNum, cpf, digits, required, min,
} from '@core/utils/validations/validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import adminCacheStoreModule from './adminCacheStoreModule'

export default {
  components: {
    BSpinner,
    BTable,
    BBadge,
    vSelect,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BFormInput,
    BForm,
    BFormGroup,
    BButtonGroup,
    BAlert,
    BackBtn,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      alphaNum,
      cpf,
      digits,
      min,
    }
  },
  methods: {
    formatDateTimeDDMMYYHHMM,
    formatCpf,
  },
  setup() {
    const type = ref('cpf')
    const userCpf = ref(null)
    const userCnpj = ref(null)
    const userCrm = ref(null)
    const userData = ref({ state: null })
    const loading = ref(false)
    const stateOptions = ref([])
    const tableColumns = ref([
      { key: 'name', sortKey: 'name', label: 'Nome' },
      { key: 'document_no', sortKey: 'document_no', label: 'CPF' },
      { key: 'partner_type', sortKey: 'partner_type', label: 'Tipo' },
    ])

    const MODULE_NAME = 'app-physician'

    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, adminCacheStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    const resetUserData = () => {
      userData.value = {}
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
      clearForm,
    } = formValidation(resetUserData)

    async function onSubmit() {
      if (loading.value) return
      loading.value = true
      const searchMap = {
        cpf: 'searchCpf',
        cnpj: 'searchCnpj',
        crm: 'searchCrm',
      }
      let data = {}
      if (type.value === 'cpf') {
        data = { document_number: userData.value.cpf }
      } else if (type.value === 'cnpj') {
        data = { document_number: normalizeCnpj(userData.value.cnpj) }
      } else {
        data = {
          crm: userData.value.crm,
          state: userData.value.state.label,
        }
      }
      store.dispatch(`${MODULE_NAME}/${searchMap[type.value]}`, data)
        .then(result => {
          loading.value = false
          if (type.value === 'cpf') {
            userCpf.value = null
          } else if (type.value === 'cnpj') {
            userCnpj.value = null
          } else {
            userCrm.value = null
          }

          if (Array.isArray(result) && result.length === 0) return

          if (type.value === 'cpf') {
            userCpf.value = result
          } else if (type.value === 'cnpj') {
            userCnpj.value = result
          } else {
            userCrm.value = result
          }
        })
        .catch(error => {
          loading.value = false
          const { errors } = error.response.data
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of Object.entries(errors)) {
            this.$refs.refFormObserver.setErrors({
              [key]: value,
            })
          }
        })
    }

    const fetchStates = () => {
      store.dispatch(`${MODULE_NAME}/fetchStates`, {})
        .then(resp => {
          stateOptions.value = resp.data
          stateOptions.value = resp.data.map(state => ({
            value: state.id,
            label: `${state.abbreviation}`,
          }))
          // eslint-disable-next-line prefer-destructuring
          userData.value.state = stateOptions.value[0]
        })
        .catch(err => {
          // TODO: subir um toats indicando o erro
          // eslint-disable-next-line no-console
          console.log(err)
        })
    }
    fetchStates()

    function openTab(tab) {
      type.value = tab
      clearForm()
    }

    function removeCpfCnpj(user) {
      if (loading.value) return
      loading.value = true
      store.dispatch(`${MODULE_NAME}/deleteCpfCnpj`, { id: user.id })
        .then(() => {
          // eslint-disable-next-line no-param-reassign
          user.deleted = true
        })
        .catch(() => {
          //
        }).finally(() => {
          loading.value = false
        })
    }
    function removeCrm(user) {
      if (loading.value) return
      loading.value = true
      store.dispatch(`${MODULE_NAME}/deleteCrm`, { id: user.id })
        .then(() => {
          // eslint-disable-next-line no-param-reassign
          user.deleted = true
        })
        .catch(() => {
          //
        }).finally(() => {
          loading.value = false
        })
    }

    return {
      CNPJ_MASK,
      formatCnpjInput,
      removeCpfCnpj,
      removeCrm,
      loading,
      type,
      openTab,
      userData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      stateOptions,
      userCpf,
      userCnpj,
      userCrm,
      tableColumns,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.deleted {
 h2, h5, .badge, strong, div {
   text-decoration: line-through !important;
 }
 div h4.text-success {
   text-decoration: none !important;
 }
}
</style>
